import { render, staticRenderFns } from "./ViewInvoiceReclamationCG.vue?vue&type=template&id=79f4d57c&"
import script from "./ViewInvoiceReclamationCG.vue?vue&type=script&lang=js&"
export * from "./ViewInvoiceReclamationCG.vue?vue&type=script&lang=js&"
import style0 from "./ViewInvoiceReclamationCG.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports